import { isEmpty } from "lodash";

export function propsToInitialState(
  data,
  trangThaiThongTinList,
  trangThaiMuaList,
  coSoSanXuatList
) {
  const dataInit = { ...data };
  // dataInit.thongTinSanXuats = data?.idThongTinSanXuat?.map(item =>
  //   thongTinSanXuatList?.find(x => x?.id === item)
  // );
  // dataInit.coSoSanXuats = data?.idCoSoSanXuat?.map(item =>
  //   coSoSanXuatList?.find(x => x?.id === item)
  // );
  dataInit.thongTinSanXuats = data?.thongTinSanXuats || null;
  dataInit.coSoSanXuats = data?.coSoSanXuats || null;
  dataInit.trangThaiTT = trangThaiThongTinList?.find(x => x?.id === data?.trangThaiThongTin) || null;

  dataInit.cheBiens = (!isEmpty(data?.lichSuCheBiens) &&
    data?.lichSuCheBiens?.map(item => ({
      tenCongDoanCheBien: item?.tenCongDoanCheBien || null,
      thoiGianBatDau: item?.thoiGianBatDau || null,
      thoiGianKetThuc: item?.thoiGianKetThuc || null,
      nguoiThucHien: item?.nguoiThucHien || null,
      diaDiemCheBien: item?.diaDiemCheBien || null,
      thongSoKyThuat: item?.thongSoKyThuat || null,
      ghiChu: item?.ghiChu || null,
      hinhAnhCheBiens: item?.hinhAnhs?.file_path
      ? [
          {
            bucket_name: item?.hinhAnhs?.bucket_name || null,
            file_path: item?.hinhAnhs?.file_path || null,
            file_oid: item?.hinhAnhs?.file_oid || 0,
            file_name: item?.hinhAnhs?.file_name || null,
            file_ext: item?.hinhAnhs?.file_ext || null,
            file_size: item?.hinhAnhs?.file_size || 0
          }
        ]
      : null
    }))) || [
    {
      tenCongDoanCheBien: null
    }
  ];

  dataInit.muaHangs = (!isEmpty(data?.lichSuMuaHangs) &&
  data?.lichSuMuaHangs?.map(item => ({
    maPhieuMua: item?.maPhieuMua || null,
    tenHangHoa: item?.tenHangHoa || null,
    ngayMua: item?.ngayMua || null,
    coSoSanXuat: coSoSanXuatList?.find(x => x?.id === item?.idCoSoSanXuat) || null,
    tenCoSoKhac: item?.tenCoSoKhac || null,
    soLuong: item?.soLuong || null,
    nguoiMua: item?.nguoiMua || null,
    ghiChu: item?.ghiChu || null,
    trangThaiMuaHang: trangThaiMuaList?.find(x => x?.id === item?.trangThaiMua) || null,
    hinhAnhMuaHangs: item?.hinhAnhs?.file_path
    ? [
        {
          bucket_name: item?.hinhAnhs?.bucket_name || null,
          file_path: item?.hinhAnhs?.file_path || null,
          file_oid: item?.hinhAnhs?.file_oid || 0,
          file_name: item?.hinhAnhs?.file_name || null,
          file_ext: item?.hinhAnhs?.file_ext || null,
          file_size: item?.hinhAnhs?.file_size || 0
        }
      ]
    : null
  }))) || [
  {
    tenCongDoanCheBien: null
  }
];

  return dataInit;
}

export function parseDataSave(value, profile) {
  const idCoSoCheBien = profile?.data?.idCoSoCheBien || 0;
  const dataSave = { ...value };
  dataSave.idThongTinSanXuat = value?.thongTinSanXuats?.map(item => item?.id);
  dataSave.idCoSoSanXuat = value?.coSoSanXuats?.map(item => item?.id);
  dataSave.trangThaiThongTin = value?.trangThaiTT?.id || 0;
  dataSave.idCoSoCheBien = idCoSoCheBien;

  dataSave.lichSuCheBiens = [];
  value?.cheBiens?.forEach(item => {
    dataSave.lichSuCheBiens.push({
      tenCongDoanCheBien: item?.tenCongDoanCheBien || null,
      thoiGianBatDau: item?.thoiGianBatDau || 0,
      thoiGianKetThuc: item?.thoiGianKetThuc || 0,
      nguoiThucHien: item?.nguoiThucHien || null,
      diaDiemCheBien: item?.diaDiemCheBien || null,
      thongSoKyThuat: item?.thongSoKyThuat || null,
      idCoSoCheBien: idCoSoCheBien,
      ghiChu: item?.ghiChu || null,
      hinhAnhs: item?.hinhAnhCheBiens?.[0]?.file_path ? item?.hinhAnhCheBiens?.[0] : null
    });
  });

  dataSave.lichSuMuaHangs = [];
  value?.muaHangs?.forEach(item => {
    dataSave.lichSuMuaHangs.push({
      maPhieuMua: item?.maPhieuMua || null,
      tenHangHoa: item?.tenHangHoa || null,
      ngayMua: item?.ngayMua || 0,
      idCoSoSanXuat: item?.coSoSanXuat?.id || 0,
      tenCoSoKhac: item?.tenCoSoKhac || null,
      soLuong: item?.soLuong || 0,
      nguoiMua: item?.nguoiMua || null,
      ghiChu: item?.ghiChu || null,
      idCoSoCheBien: idCoSoCheBien,
      trangThaiMua: item?.trangThaiMuaHang?.id || 0,
      hinhAnhs: item?.hinhAnhMuaHangs?.[0]?.file_path ? item?.hinhAnhMuaHangs?.[0] : null
    });
  });
  
  return dataSave;
}
